import { Component, Inject, Injector, ViewEncapsulation, ChangeDetectionStrategy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { AbstractComponent } from '../../../commons/abstract.component';
import { WavoipService } from '../../../services/wavoip/wavoip.service';
import { Contact } from '../../../models/contact.model';

@Component({
    selector: 'call-phone-component',
    templateUrl: './call-phone.v2.component.html',
    styleUrls: ['./call-phone.component.scss'],
    encapsulation: ViewEncapsulation.None,
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class CallPhoneComponent extends AbstractComponent {
    private intervalId: any;

    duration: number = 0;
    calling: boolean = false;
    dialing: boolean = false;
    callEnded: boolean = false;
    finalDuration: string = '';

    constructor(
        injector: Injector,
        public _matDialogRef: MatDialogRef<CallPhoneComponent>,
        private wavoipService: WavoipService,
        @Inject(MAT_DIALOG_DATA) public data: Contact,
    ) {
        super(injector);
        this.startWavoip();
    }

    ngOnInit(): void {
        document.addEventListener('wavoip-call-ended', this.handleCallEndedByClient.bind(this));
        document.addEventListener('wavoip-call-answered', this.handleCallAnswered.bind(this));
    }

    override ngOnDestroy(): void {
        if (this.intervalId) {
            clearInterval(this.intervalId);
        }
        
        document.removeEventListener('wavoip-call-ended', this.handleCallEndedByClient.bind(this));
        document.removeEventListener('wavoip-call-answered', this.handleCallAnswered.bind(this));
        
        super.ngOnDestroy();
    }

    private async startWavoip(): Promise<void> {
        // @TODO: Mock token
        // await this.wavoipService.startDevice('51c56a8d-b7ba-4416-b77b-ed946ac1aba8'); // token canal do suporte
        await this.wavoipService.startDevice('b1ee0760-5c84-42c0-b9d4-3109bc3b3242'); // token canal do comercial
    }

    public async startCallWavoip(): Promise<void> {
        if (!!this.data) {
            this.dialing = true;
            this.calling = false;
            this.duration = 0;
            this.callEnded = false;
            this.finalDuration = '';
            
            await this.wavoipService.startCall(this.data.phone);
        } else {
            this.calling = false;
            this.dialing = false;
            this.alertService.info(this.t('shared.callPhone.contactNotFound'));
        }
    }

    private handleCallAnswered(event: CustomEvent): void {
        if (this.dialing) {
            this.dialing = false;
            this.calling = true;
            
            this.intervalId = setInterval(() => {
                this.duration++;
            }, 1000);
        }
    }

    private handleCallEndedByClient(event: CustomEvent): void {
        if (this.calling || this.dialing) {
            this.finalDuration = this.formatTimeCall();
            this.calling = false;
            this.dialing = false;
            this.callEnded = true;
            
            if (this.intervalId) {
                clearInterval(this.intervalId);
                this.intervalId = null;
            }
        }
    }

    public async endCallWavoip(): Promise<void> {
        this.finalDuration = this.formatTimeCall();
        this.calling = false;
        this.dialing = false;
        this.callEnded = true;
            
        if (this.intervalId) {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
        this.wavoipService.endCall();
    }

    async onClose(): Promise<void> {
        if (this.calling || this.dialing) {
            await this.endCallWavoip();
        } else {
            this._matDialogRef.close();
        }
    }
    
    formatTimeCall(): string {
        const hours = Math.floor(this.duration / 3600);
        const minutes = Math.floor((this.duration % 3600) / 60);
        const seconds = this.duration % 60;

        const time = (num: number) => (num < 10 ? `0${num}` : num);

        return `${time(hours)}:${time(minutes)}:${time(seconds)}`;
    }
}